import {WithdrawApplication} from "src/rds/types/crowdbank/t_withdraw";
import {WithdrawTask} from "src/rds/types/crowdbank/t_withdraw_task";


interface CSVRow {
  separator: boolean,     // 区切
  date: string,           // 計上日
  header_outline: string, // 仕訳ヘッダ摘要
  item_code: string       // 勘定科目コード
  debit: number | null    // 借方金額
  credit: number | null   // 貸方金額
  outline: string         // 摘要
  partner?: string        // 取引先コード
}


function isEffectiveWithdrawal(task: WithdrawTask, elem: WithdrawApplication): boolean {
  // RDS (mysql2) returns cancel_flg as 0/1, not boolean false
  return !elem.cancel_flg
      && !task.data.cancels.at_register.includes(elem.record_number);
}


export function convert(task: WithdrawTask & { process_date_next: string | null }, list: WithdrawApplication[], goldBuying: number): string {

  const results: CSVRow[] = [];

  const process_date        = task.process_date_next!,
        cancel_date         = new Date(task.data.process_date).toYmd(),
        withdraw_date_slash = new Date(task.data.process_date).toYmdSlash(),
        date_suffix         = `(${withdraw_date_slash}出金)`,
        effective_count     = list.filter(elem => isEffectiveWithdrawal(task, elem)).length,
        header_outline      = `CB出金 ${effective_count}件`,
        cancels             = [] as WithdrawApplication[];


  // 合計金額
  let total = 0;

  for (const elem of list) {

    // 有効出金申請以外は除外（顧客キャンセル・登録時キャンセル。CBK-CBN-RD-BO-001-FR-07）
    if (!isEffectiveWithdrawal(task, elem)) {
      continue;
    }

    total += elem.amount.toNumber();

    results.push({
      separator: false,
      date     : process_date,
      header_outline,
      item_code: '300010002',
      debit    : elem.amount.toNumber(),
      credit   : null,
      outline  : `CB出金${elem.proc_account_name}`
    })

    if (task.data.cancels.after_register.includes(elem.record_number)) {
      cancels.push(elem);
    }
  }

  // 先頭行

  // 出金額＋金の買い越し金額 が 1億円以下
  if ((total + goldBuying) < 100_000_000) {
    results.unshift({
      separator: true,
      date     : process_date,
      header_outline,
      item_code: '130010000',
      debit    : null,
      credit   : total,
      outline  : `${header_outline}${date_suffix}`,
    });

  } else {

    results.unshift({
      separator: true,
      date     : process_date,
      header_outline,
      item_code: '130010000',
      debit    : null,
      credit   : 100_000_000 - goldBuying,
      outline  : `${header_outline}/1億円から地金購入除いた額`,
    }, {
      separator: false,
      date     : process_date,
      header_outline,
      item_code: '133010008',
      debit    : null,
      credit   : total - (100_000_000 - goldBuying),
      outline  : `${header_outline}/1億円超え部分(信託取崩額)`,
      partner  : '20250306',
    });
  }


  // キャンセル
  const cancel_outline = `CB出金 振込ｴﾗｰ${cancels.length}件`;

  cancels.forEach((elem, index) => {
    results.push({
      separator     : index === 0,
      date          : cancel_date,
      header_outline: cancel_outline,
      item_code     : '300010002',
      debit         : null,
      credit        : elem.amount.toNumber(),
      outline       : `CB出金ｴﾗｰ ${elem.proc_account_name}`
    }, {
      separator     : false,
      date          : cancel_date,
      header_outline: cancel_outline,
      item_code     : '100030021',
      debit         : elem.amount.toNumber(),
      credit        : null,
      outline       : `CB出金ｴﾗｰ ${elem.proc_account_name}`
    })
  })

  const header = `"${[
    '区切(*)',
    '企業(10)',
    '会社',
    '本支店(1)',
    '仕訳タイプ',
    '計上日',
    '仕訳ヘッダ摘要(半角40文字まで)',
    '勘定科目コード',
    '通貨',
    'レート',
    '借方(外貨)金額',
    '借方金額',
    '貸方(外貨)金額',
    '貸方金額',
    '消費税額',
    '税区分コード',
    '外税内税区分',
    '税率コード',
    '組織コード',
    '取引先コード',
    'ﾌﾟﾛｼﾞｪｸﾄｺｰﾄﾞ',
    '参照番号(半角20文字まで)',
    '摘要補助(半角40文字まで)',
    '摘要(半角40文字まで)'
  ].join('","')}"`;

  const body = results.map(elem => `"${[
    elem.separator ? '*' : '',                                   // 区切(*)
    10,                                                          // 企業(10)
    20,                                                          // 会社
    1,                                                           // 本支店(1)
    'JNL',                                                       // 仕訳タイプ
    elem.date,                                                   // 計上日
    `${elem.header_outline}${date_suffix}${(total + goldBuying) >= 100_000_000 ? (goldBuying > 0 ? '*1億↑金ｱﾘ' : '*1億↑金ﾅｼ') : ''}`, // 仕訳ヘッダ摘要(半角40文字まで)
    elem.item_code,                                              // 勘定科目コード
    'YEN',                                                       // 通貨
    '',                                                          // レート
    '',                                                          // 借方(外貨)金額
    elem.debit ?? '',                                            // 借方金額
    null,                                                        // 貸方(外貨)金額
    elem.credit ?? '',                                           // 貸方金額
    0,                                                           // 消費税額
    99,                                                          // 税区分コード
    'N',                                                         // 外税内税区分
    0,                                                           // 税率コード
    'C900',                                                      // 組織コード
    elem.partner ?? '20170799999',                               // 取引先コード
    '',                                                          // ﾌﾟﾛｼﾞｪｸﾄｺｰﾄﾞ
    '',                                                          // 参照番号(半角20文字まで)
    '',                                                          // 摘要補助(半角40文字まで)
    elem.outline                                                 // 摘要(半角40文字まで)
  ].join('","')}"`)

  return [header, ...body].join("\r\n");
}

